import { Observable } from 'rxjs';
import { FileResult } from '@imagise/entities';

export function extractBase64Payload(dataUrl: string): string {
  const splitIndex = dataUrl.indexOf(',');
  return splitIndex >= 0 ? dataUrl.slice(splitIndex + 1) : dataUrl;
}

export function buildMergedFileName(sourceFileName: string | undefined): string {
  const fileName = sourceFileName || 'image.png';
  const dotIndex = fileName.lastIndexOf('.');
  const name = dotIndex > 0 ? fileName.slice(0, dotIndex) : fileName;
  return `${name}-merged.png`;
}

/**
 * Wraps a locally produced blob (merged/flattened layer composition) into the
 * FileResult shape the editor pipeline expects from the upload API.
 */
export function createFileResultFromBlob(
  blob: Blob,
  fileName: string,
  idUpload: string,
): Observable<FileResult> {
  return new Observable<FileResult>(observer => {
    const reader = new FileReader();

    reader.onload = () => {
      const dataUrl = String(reader.result || '');
      const base64 = extractBase64Payload(dataUrl);
      const objectUrl = URL.createObjectURL(blob);

      observer.next({
        IsSuccess: true,
        idError: '',
        id: `merged-${Date.now()}`,
        FileName: fileName,
        UploadFileName: '',
        idUpload,
        FileLength: blob.size,
        SourceBase64: base64,
        SourceMimeType: blob.type || 'image/png',
        LocalObjectUrl: objectUrl,
        FileBlob: blob,
      });
      observer.complete();
    };

    reader.onerror = () => {
      observer.error(reader.error ?? new Error('Failed to read merged image.'));
    };

    reader.readAsDataURL(blob);

    return () => {
      if (reader.readyState === FileReader.LOADING) {
        reader.abort();
      }
    };
  });
}
